<template>
  <a-card :bordered="false">
    <div>
      <s-table
        bordered
        ref="table"
        size="small"
        rowKey="id"
        :loading="loading"
        :columns="columns"
        :data="loadData"
        :scroll="{ x: 1000 }"
      >
        <span slot="serial" slot-scope="text, record, index">
          {{ index + 1 }}
        </span>
        <div slot="money_render" slot-scope="text" style="text-align: right; min-width: 90px; max-width: 300px">
          {{ (text / 1).toFixed(2) | numberFormat }}
        </div>
        <span slot="approval_needed" slot-scope="text">
          <span>{{ text ? '是' : '否' }}</span>
        </span>
        <span slot="action" slot-scope="text, record">
          <a @click="handleAdjustmentDetail(record)" v-if="record.is_adjustment">查看调整</a>
          <template v-if="false">
            <a @click="handleAttachment(record)">附件</a>
            <a-divider type="vertical" />
            <a @click="handleAdjustment(record)">库存调整</a>
            <a-divider type="vertical" />
            <!--          <a @click="handleEdit(record)">编辑</a>-->
            <!--          <a-divider type="vertical" />-->
            <a-popconfirm
              title="确定要删除么？"
              ok-text="确定"
              cancel-text="取消"
              @confirm="handleDelete(record)"
            >
              <a>删除</a>
            </a-popconfirm>
          </template>
        </span>
      </s-table>
      <a-drawer
        title="库存调整"
        placement="right"
        :closable="false"
        :visible="visibleDrawer"
        @close="onClose"
        width="500">
        <a-spin :spinning="drawerLoading" v-if="inventoryAdjustmentObj">
          <div :title="inventoryAdjustmentObj.name">
            <span class="desc_item_drawer">仓库：{{ inventoryAdjustmentObj.warehouse }}</span><br>
            <span class="desc_item_drawer">数量：{{ (inventoryAdjustmentObj.count / 1).toFixed(2) | numberFormat }}</span><br>
            <span class="desc_item_drawer">单位：{{ $Dictionaries.unit[inventoryAdjustmentObj.unit] }}</span><br>
            <span class="desc_item_drawer">预估人民币单价：{{ (inventoryAdjustmentObj.unit_price_cny / 1).toFixed(2) | numberFormat }} </span><br>
            <span class="desc_item_drawer">已开启审批：{{ inventoryAdjustmentObj.is_approval_needed ? '是' : '否' }}</span><br>
            <span class="desc_item_drawer">审批状态：<span :class="statusText[inventoryAdjustmentObj.status < 0 ? 0 : inventoryAdjustmentObj.status][0]">{{ inventoryAdjustmentObj.is_approval_needed ? ($Dictionaries.approval_result[inventoryAdjustmentObj.status] ? $Dictionaries.approval_result[inventoryAdjustmentObj.status] : '无') : '未开启审批' }}</span></span><br>
            <span class="desc_item_drawer">已存档：{{ inventoryAdjustmentObj.is_archived ? '是' : '否' }}</span><br>
            <span class="desc_item_drawer">创建时间：{{ inventoryAdjustmentObj.create_time | dayjs }}</span>
            <div v-if="false">
              <a-collapse :bordered="false">
                <template #expandIcon="props">
                  <a-icon type="caret-right" :rotate="props.isActive ? 90 : 0" />
                </template>
                <a-collapse-panel key="1" header="附件" :style="customStyle" v-if="inventoryAdjustmentObj.attachment.length > 0">
                  <a v-for="(attachment) in inventoryAdjustmentObj.attachment" :key="attachment.id" :href="attachment.url" target="_blank" class="desc_item_drawer"><a-icon type="file" theme="filled" /> {{ attachment.name }}</a>
                </a-collapse-panel>
              </a-collapse>
            </div>
          </div>
        </a-spin>
      </a-drawer>
    </div>
  </a-card>
</template>

<script>
import { STable } from '@/components'
import {
  inventory_delete,
  inventory_archived
} from '@/api/trade_inventory'
import debounce from 'lodash/debounce'
import { project_list, trade_project_report_form } from '@/api/trade_project'
import { warehouse_list } from '@/api/trade_warehouse'
import { inventory_adjustment_list } from '@/api/trade_inventory_adjustment'

export default {
  name: 'TableList',
  components: {
    STable
  },
  data () {
    this.projectSearch = debounce(this.handleProjectSearch, 800)
    this.warehouseSearch = debounce(this.handleWarehouseSearch, 800)
    return {
      approval_again: false,
      loading: false,
      confirmLoading: false,
      drawerLoading: false,
      // 创建窗口控制
      visibleDrawer: false,
      inventoryAdjustmentObj: undefined,
      statusText: {
        0: ['none', '无'],
        1: ['waiting', '审批中'],
        2: ['pass', '通过'],
        3: ['un_pass', '驳回']
      },
      visible: false,
      archived_visible: false,
      mdl: {},
      projectList: [],
      warehouseList: [],
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '序号',
          width: 50,
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '项目',
          dataIndex: 'name',
          width: 150,
          ellipsis: true
        },
        {
          title: '项目编号',
          dataIndex: 'number',
          width: 150,
          ellipsis: true
        },
        {
          title: '发起人',
          dataIndex: 'create_by',
          width: 150,
          ellipsis: true
        },
        {
          title: '参与人',
          dataIndex: 'participants',
          width: 150,
          ellipsis: true
        },
        {
          title: '交易品种',
          dataIndex: 'category_name',
          width: 150,
          ellipsis: true
        },
        {
          title: '起止时间',
          dataIndex: 'start_date',
          width: 180,
          ellipsis: true,
          customRender: (text, record) => text + '~' + record.end_date
        },
        {
          title: '上游',
          dataIndex: 'buy_contract',
          width: 180,
          ellipsis: true
        },
        {
          title: '下游',
          dataIndex: 'sell_contract',
          width: 180,
          ellipsis: true
        },
        {
          title: '合同采购数量',
          dataIndex: 'buy_contract_count',
          scopedSlots: { customRender: 'money_render' },
          align: 'right',
          width: 180,
          ellipsis: true
        },
        {
          title: '库存入库量',
          dataIndex: 'inventory_in_count',
          scopedSlots: { customRender: 'money_render' },
          align: 'right',
          width: 180,
          ellipsis: true
        },
        {
          title: '采购付款金额（CNY）',
          dataIndex: 'buy_amount',
          scopedSlots: { customRender: 'money_render' },
          align: 'right',
          width: 180,
          ellipsis: true
        },
        {
          title: '采购不含税金额',
          dataIndex: 'buy_excluding_tax_amount',
          scopedSlots: { customRender: 'money_render' },
          align: 'right',
          width: 180,
          ellipsis: true
        },
        {
          title: '合同销售量',
          dataIndex: 'contract_sell_count',
          scopedSlots: { customRender: 'money_render' },
          align: 'right',
          width: 180,
          ellipsis: true
        },
        {
          title: '库存出库量',
          dataIndex: 'inventory_out_count',
          scopedSlots: { customRender: 'money_render' },
          align: 'right',
          width: 180,
          ellipsis: true
        },
        {
          title: '出库销售金额',
          dataIndex: 'sell_amount',
          scopedSlots: { customRender: 'money_render' },
          align: 'right',
          width: 180,
          ellipsis: true
        },
        {
          title: '销售不含税金额',
          dataIndex: 'sell_excluding_tax_amount',
          scopedSlots: { customRender: 'money_render' },
          align: 'right',
          width: 180,
          ellipsis: true
        },
        {
          title: '库存量（入库-出库）',
          dataIndex: 'inventory_count',
          scopedSlots: { customRender: 'money_render' },
          align: 'right',
          width: 180,
          ellipsis: true
        },
        {
          title: '港口费用（监装合同）',
          dataIndex: 'contract_supervision_total_fee',
          scopedSlots: { customRender: 'money_render' },
          align: 'center',
          width: 300,
          ellipsis: true,
          children: [
            {
              title: '含税',
              dataIndex: 'contract_supervision_total_fee',
              width: 150,
              align: 'right',
              scopedSlots: { customRender: 'money_render' }
            },
            {
              title: '不含税',
              dataIndex: 'contract_supervision_total_fee_no_tax',
              width: 150,
              align: 'right',
              scopedSlots: { customRender: 'money_render' }
            }
          ]
        },
        {
          title: '仓储费（仓储合同）',
          align: 'center',
          width: 300,
          ellipsis: true,
          children: [
            {
              title: '含税',
              dataIndex: 'contract_storage_total_fee',
              width: 150,
              align: 'right',
              scopedSlots: { customRender: 'money_render' }
            },
            {
              title: '不含税',
              dataIndex: 'contract_storage_total_fee_no_tax',
              width: 150,
              align: 'right',
              scopedSlots: { customRender: 'money_render' }
            }
          ]
        },
        {
          title: '货代费（货代合同、报关合同）',
          align: 'center',
          width: 300,
          ellipsis: true,
          children: [
            {
              title: '含税',
              dataIndex: 'contract_forwarder_customs_declaration_total_fee',
              width: 150,
              align: 'right',
              scopedSlots: { customRender: 'money_render' }
            },
            {
              title: '不含税',
              dataIndex: 'contract_forwarder_customs_declaration_total_fee_no_tax',
              width: 150,
              align: 'right',
              scopedSlots: { customRender: 'money_render' }
            }
          ]
        },
        {
          title: '运输费（运输合同、租船合同、订舱合同）',
          align: 'center',
          width: 300,
          ellipsis: true,
          children: [
            {
              title: '含税',
              dataIndex: 'contract_tbc_total_fee',
              width: 150,
              align: 'right',
              scopedSlots: { customRender: 'money_render' }
            },
            {
              title: '不含税',
              dataIndex: 'contract_tbc_total_fee_no_tax',
              width: 150,
              align: 'right',
              scopedSlots: { customRender: 'money_render' }
            }
          ]
        },
        {
          title: '保险费（保险合同）',
          align: 'center',
          width: 300,
          ellipsis: true,
          children: [
            {
              title: '含税',
              dataIndex: 'contract_insurance_total_fee',
              width: 150,
              align: 'right',
              scopedSlots: { customRender: 'money_render' }
            },
            {
              title: '不含税',
              dataIndex: 'contract_insurance_total_fee_no_tax',
              width: 150,
              align: 'right',
              scopedSlots: { customRender: 'money_render' }
            }
          ]
        },
        {
          title: '其他业务费用（其他所有合同）',
          align: 'center',
          width: 300,
          ellipsis: true,
          children: [
            {
              title: '含税',
              dataIndex: 'contract_other_total_fee',
              width: 150,
              align: 'right',
              scopedSlots: { customRender: 'money_render' }
            },
            {
              title: '不含税',
              dataIndex: 'contract_other_total_fee_no_tax',
              width: 150,
              align: 'right',
              scopedSlots: { customRender: 'money_render' }
            }
          ]
        },
        {
          title: () => '资金占用 (资金实际占用金额* 天数)',
          dataIndex: 'fund_occupation',
          scopedSlots: { customRender: 'money_render' },
          align: 'right',
          width: 240,
          ellipsis: true
        },
        {
          title: '毛利1（销售金额-采购金额）',
          dataIndex: 'gross_margin1',
          scopedSlots: { customRender: 'money_render' },
          align: 'right',
          width: 200,
          ellipsis: true
        },
        {
          title: '毛利2（毛利1-各种费用）',
          dataIndex: 'gross_margin2',
          scopedSlots: { customRender: 'money_render' },
          align: 'right',
          width: 200,
          ellipsis: true
        },
        {
          title: '附加税',
          dataIndex: 'additional_tax',
          scopedSlots: { customRender: 'money_render' },
          align: 'right',
          width: 150,
          ellipsis: true
        },
        {
          title: '印花税',
          dataIndex: 'stamp_tax',
          scopedSlots: { customRender: 'money_render' },
          align: 'right',
          width: 150,
          ellipsis: true
        },
        {
          title: '利润（毛利2-税）',
          dataIndex: 'profit',
          scopedSlots: { customRender: 'money_render' },
          align: 'right',
          width: 150,
          ellipsis: true
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        console.log('loadData.parameter', parameter)
        return trade_project_report_form(Object.assign(parameter, this.queryParam))
          .then(res => {
            console.log(res.data, '我是数据列表@')
            return res.data
          })
      },
      selectedRowKeys: [],
      selectedRows: [],

      // custom table alert & rowSelection
      options: {
        alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
        rowSelection: {
          getCheckboxProps: record => ({
            props: {
              disabled: record.is_archived
            }
          }),
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: false
    }
  },
  created () {
    this.tableOption()
    this.handleProjectSearch(undefined)
    this.handleWarehouseSearch(undefined)
  },
  methods: {
    tableOption () {
      if (!this.optionAlertShow) {
        this.options = {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            getCheckboxProps: record => ({
              props: {
                disabled: record.is_archived
              }
            }),
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleAdd () {
      this.mdl = null
      this.visible = true
    },
    handleArchived () {
      if (this.selectedRowKeys.length > 0) {
        this.archived_visible = true
      } else {
        this.$message.info('选择存档记录')
      }
    },
    handleAddCancel () {
      this.visible = false
      const form = this.$refs.createModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleArchivedCancel () {
      this.archived_visible = false
      const form = this.$refs.archivedModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleAttachment (record) {
      // this.$emit('onEdit', record)
      this.$router.push({ path: '/trade/inventory/' + record.id + '/attachment', query: { project: record.project, warehouse: record.warehouse } })
    },
    handleAdjustment (record) {
      this.$router.push({ path: '/trade/inventory/' + record.id + '/adjustment', query: { project: record.project, warehouse: record.warehouse } })
    },
    handleAdjustmentDetail (record) {
      this.inventoryAdjustmentObj = undefined
      this.visibleDrawer = true
      this.drawerLoading = true
      inventory_adjustment_list({ inventory_id: record.id }).then(res => {
        if (res.code === 1000) {
          if (res.data.entries && res.data.entries.length > 0) {
            this.inventoryAdjustmentObj = res.data.entries[0]
          }
        }
      }).finally(() => {
        this.drawerLoading = false
      })
    },
    onClose () {
      this.visibleDrawer = false
    },
    handleEdit (record) {
      this.$emit('onEdit', record)
      // this.$router.push({ path: '/trade/bank/' + record.id })
    },
    handleDelete (record) {
      inventory_delete(record.id).then((res) => {
        console.log(res)
        console.log('删除成功------')

        this.$refs.table.refresh()
      })
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    handleProjectSearch (value) {
      project_list({ name: value }).then((res) => {
        const result = res.data.entries || []
        this.projectList = !value ? (result.length > 5 ? result.slice(0, 5) : result) : result
      })
    },
    handleProjectChange (value) {
      console.log(value)
      if (value === undefined) {
        this.handleProjectSearch(value)
      }
    },
    handleWarehouseSearch (value) {
      warehouse_list({ name: value }).then((res) => {
        const result = res.data.entries || []
        this.warehouseList = !value ? (result.length > 5 ? result.slice(0, 5) : result) : result
      })
    },
    handleWarehouseChange (value) {
      console.log(value)
      if (value === undefined) {
        this.handleWarehouseSearch(value)
      }
    },
    handleArchivedOK () {
      const form = this.$refs.archivedModal.form
      this.confirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
          const data = {
            ids: this.selectedRowKeys,
            ...values
          }
          inventory_archived(data).then(res => {
            // 刷新表格
            if (res.code === 1000) {
              this.$refs.table.refresh()
            }
          }).finally(() => {
            this.archived_visible = false
            this.confirmLoading = false
          })
        } else {
          this.confirmLoading = false
        }
      })
    }
  }
}
</script>
<style scoped>
.desc_item_drawer {
  padding-left: 20px;
  height: 50px;
  line-height: 50px;
}
</style>
